<template>
  <div style="height: 100%">
    <cms-nav-bar
      postName="附件预览"
      style="color: rgba(34, 34, 34, 1); background: #ffffff"
    />
    <img
      @click="goback()"
      class="goImg"
      src="../../../assets/images/cms/jt.png"
    />
    <iframe
      ref="pdfIframe"
      class="pdfiframe"
      :src="url"
      frameborder="0"
      scrolling="auto"
      :onload="adjustIframe"
      :width="width"
      :height="height"
    />
  </div>
</template>

<script>
export default {
  name: "PdfShow",
  props:{
    isModel:{
      default:false,
      type:Boolean,
    }
  },
  data() {
    return {
      url: "",
      width: 0,
      height: 0,
    };
  },
  created() {
    this.url =
      this.$store.state.httpHost.kkFileView + sessionStorage.getItem("pdfUrl");
    this.width = document.documentElement.clientWidth;
    this.height = document.documentElement.clientHeight - 40;
  },
  mounted(){
    setTimeout(() => {
      this.adjustIframe()
    }, 2000);
  },
  methods: {
    goback() {
      if(this.isModel){
        this.$emit("closePdfModel")
      }else{
        this.$router.back();
      }
    },

    adjustIframe() {
      var ifm = this.$refs.pdfIframe;
      ifm.contentWindow.document //获取到iframe的window //获取到iframe的document
        .getElementsByClassName("my-photo").style.zoom = "50%"; //正常获取元素 //修改样式
    },
  },
};
</script>

<style scoped lang="less">
.goImg {
  position: fixed;
  left: 12px;
  top: 12px;
  width: 20px;
  //padding-top: 10px;
  box-sizing: border-box;
  //display: table-cell;
  vertical-align: text-top;
  z-index: 999;
}
.pdfiframe {
  transform: scaleX(0.5) SCALEY(0.5);
  width: 224%;
  height: 189%;
  margin: -62%;
  position: absolute;
  bottom: -14%;
  left: 0;

  /*- scrollbar -*/
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #999;
    -webkit-border-radius: 5px;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb:vertical:hover {
    background-color: #666;
  }
  &::-webkit-scrollbar-thumb:vertical:active {
    background-color: #333;
  }
  &::-webkit-scrollbar-button {
    display: none;
  }
  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homePage/pdfShow/pdfShow.vue